import axios from "axios";
import history from '../history';
import * as type from "./types";
import { REGISTER_PACKAGE_SUCCESS, REGISTER_PACKAGE_POST_ERROR, REGISTER_PACKAGE_ERROR, SESSION_INVALID, DDOS_SUSPECTED, POST_ERROR, REGISTER_MAIN_USER_SUCCESS } from "./types";
import { API_URL_DOMAIN,API_URL_DOMAIN2 } from "../utils/constants";
//test.geotech.solutions
const API_URL2 = "https://"+API_URL_DOMAIN2+"/gtsql";
const API_URL = "https://"+API_URL_DOMAIN+"/gtsql";
const SW_API_URL = "https://swapi.co/api";

const getSessionKey = () => {
  const k = localStorage.getItem("sessionKey");
  if (!k || k === "undefined" || k === "null") return null;
  return k;
};

export const signUp = (user, history) => async dispatch => {
  const {
    companyName,
    contact,
    email,
    fax,
    password,
    registrationNumber,
    username,
    roleList,
  } = user;
    const query = `query{insertuserregistration(loginusername:"", username:"${username}",password:"${password}",companyName:"${companyName}",regNo:"${registrationNumber}",phone:"${contact}",fax: "${fax}",mailAddress: "${email}", roleIds:"[${roleList}]", sessionKey:"${localStorage.getItem("sessionKey"
  )}") { message, success }}`;
  const res = await axios.post(API_URL, JSON.stringify(getBody(query)));
  const data = res.data.data;
  try {
    if (data.insertuserregistration.success) {
      dispatch({
        type: type.SIGNUP_SUCCESS,
        payload: "You have succesfully signed up. Sign in to get started"
      });
      history.push("/");
    } else {
      // Registration fails
      dispatch({
        type: type.SIGNUP_ERROR,
        payload: data.insertuserregistration.message
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({
        type: type.SIGNUP_ERROR,
        payload: res.errors
      });
  }
};

export const signUpMem = (user, history) => async dispatch => {
  const {
    companyName,
    contact,
    email,
    fax,
    password,
    registrationNumber,
    username,
    roleList,
  } = user;
    const query = `query{insertuserregistration( username:"${username}",password:"${password}",companyName:"${companyName}",
    regNo:"${registrationNumber}",phone:"${contact}",fax: "${fax}",email: "${email}", roleIds:"[1]", sessionKey:"") { message, success }}`;
  const res = await axios.post(API_URL, JSON.stringify(getBody(query)));
  const data = res.data.data;
  try {
    if (data.insertuserregistration.success) {
      dispatch({
        type: type.SIGNUP_SUCCESS,
        payload: "You have succesfully signed up. ACTIVATE your account from the link that was sent to your email. Thank you"
      });
      history.push("/");
    } else {
      // Registration fails
      dispatch({
        type: type.SIGNUP_ERROR,
        payload: data.insertuserregistration.message
      });
      console.log(data);
    }
  } catch (error) {
    console.log(error);
  }
};

export const loginAct = (user, history) => async dispatch => {
    const { username, password } = user;
  const query = `query{login( username:"${username}", password:"${password}") { message, success,sessionKey,apiKey }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(reponse => {
        const data = reponse.data.data;
        const sk = data.login && data.login.sessionKey;
        if (data.login.success && typeof sk === "string" && sk.length > 0) {
            localStorage.setItem("sessionKey", sk);
            localStorage.setItem("username", username);
            if(data.login.apiKey != null)
            localStorage.setItem("apiKey", data.login.apiKey);
            // Redirect
            dispatch({ type: type.LOGIN_SUCCESS, payload: data.login.message, key: guid() });
            history.push("/dashboard");
        } else {
            dispatch({ type: type.LOGIN_ERROR, payload: data.login.message || "Invalid session", key: guid() });
        }
        }).catch(error => {
            dispatch({ type: type.LOGIN_POST_ERROR, key: guid(), error: error.message });
    });
};





export const fetchReportList = (data) => async dispatch => { 
    let consentStr = ''
    data.consent !== null ? 
        consentStr = `consent:${data.consent}`
        :
        consentStr = ``
    const query = `query{getreportlist( dateFrom:"${data.dateFrom}", dateTo:"${data.dateTo}", ${consentStr} , status:"${data.report_status}", fire_status:"${data.fire_status}",type:"${data.source}",country:"${data.country}",isprotected:${data.isprotected},ispeat:${data.ispeat},groupName:"${data.groupName}",sessionkey:"${localStorage.sessionKey}") {  filepaths,encname, report_title,report_date,latitude,company_group,longitude,fire_status,cause,member_name,country,acqdate,confidence,source,status,ispeat,isprotected,province,iscertified, consent, npp, nppType}}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.getreportlist.length > 0) {
              dispatch({ 
                  type: type.GET_REPORT_LIST_SUCCESS, 
                  payload: data.getreportlist,
                  key:guid(),
                  });
              
          } else {
              dispatch({ 
                  type: type.GET_REPORT_LIST_ERROR, 
                  payload: 'Error or NULL result retrieving reports',
                  key:guid(),
                  });
              
          }
          }).catch(error => {
              dispatch({ type: type.GET_REPORT_LIST_POST_ERROR, key: guid(), error: error.message });
      });
  };
  
  
export const fetchGroupList = (data) => async dispatch => {
    const sk = getSessionKey();
    if (!sk) {
        dispatch({ type: type.GET_GROUP_LIST_ERROR, payload: 'Session expired. Please log in again.', key: guid() });
        return;
    }
    const query = `query{fetchGroupList( sessionkey:"${sk}") {  group_name, id}}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.fetchGroupList.length > 0) {
              dispatch({ 
                  type: type.GET_GROUP_LIST_SUCCESS, 
                  payload: data.fetchGroupList,
                  key:guid(),
                  });
              
          } else {
              dispatch({ 
                  type: type.GET_GROUP_LIST_ERROR, 
                  payload: 'Error or NULL result retrieving reports',
                  key:guid(),
                  });
              
          }
          }).catch(error => {
              dispatch({ type: type.GET_GROUP_LIST_POST_ERROR, key: guid(), error: error.message });
      });
  };
  

  
  export const fetchReportListShape = (data) => async dispatch => { 
    let consentStr = ''
    data.consent !== null ? 
        consentStr = `consent:${data.consent}`
        :
        consentStr = ``
    const query = `query{getreportshapefile( dateFrom:"${data.dateFrom}", dateTo:"${data.dateTo}", ${consentStr}, status:"${data.report_status}",type:"${data.source}",country:"${data.country}",isprotected:${data.isprotected},ispeat:${data.ispeat},groupName:"${data.groupName}",sessionkey:"${localStorage.sessionKey}") {  content}}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data; 
          if (data.getreportshapefile.content !== "") {
              dispatch({ 
                  type: type.GET_REPORT_SHAPE_LIST_SUCCESS, 
                  payload: data.getreportshapefile
                  });
              
          } else {
              dispatch({ 
                  type: type.GET_REPORT_LIST_ERROR, 
                  payload: 'Error retrieving reports'
                  });
              
          }
          }).catch(error => {
              dispatch({ type: type.GET_REPORT_LIST_POST_ERROR, key: guid(), error: error.message });
      });
  };
  
export const fetchReportListCSV = (data) => async dispatch => { 
    let consentStr = ''
    data.consent !== null ? 
        consentStr = `consent:${data.consent}`
        :
        consentStr = ``
    const query = `query{getreportlistcsv( dateFrom:"${data.dateFrom}", dateTo:"${data.dateTo}", ${consentStr}, status:"${data.report_status}",type:"${data.source}",country:"${data.country}",isprotected:${data.isprotected},ispeat:${data.ispeat},groupName:"${data.groupName}",sessionkey:"${localStorage.sessionKey}") {  content}}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data; 
          if (data.getreportlistcsv.content !== "") {
              dispatch({ 
                  type: type.GET_REPORT_CSV_LIST_SUCCESS, 
                  payload: data.getreportlistcsv
                  });
              
          } else {
              dispatch({ 
                  type: type.GET_REPORT_LIST_ERROR, 
                  payload: 'Error retrieving reports'
                  });
              
          }
          }).catch(error => {
              dispatch({ type: type.GET_REPORT_LIST_POST_ERROR, key: guid(), error: error.message });
      });
  };
  

export const fetchRawModis = (modis) => async dispatch => { 
  const query = `query{getmodis( dateFrom:"${modis.dateFrom}", dateTo:"${modis.dateTo}",sessionkey:"${localStorage.sessionKey}") { acqdate, acqtime,latitude, longitude,confidence, bright_t31, brightness, day_night }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(reponse => {
        const data = reponse.data.data;
        if (data.getmodis.length > 0) {
            dispatch({ 
                type: type.GET_ALL_MODIS_SUCCESS, 
                payload: data.getmodis
                });
            
        } else {
            dispatch({ 
                type: type.GET_ALL_HOTSPOT_ERROR, 
                payload: 'Error retrieving modis'
                });
            
        }
        }).catch(error => {
            dispatch({ type: type.GET_ALL_HOTSPOT_POST_ERROR, key: guid(), error: error.message });
    });
};




export const fetchTriggered = (hotspot) => async dispatch => { 
    const query = `query{getfilteredhotspot( dateFrom:"${hotspot.dateFrom}",type:"${hotspot.type}", status:"${hotspot.status}", dateTo:"${hotspot.dateTo}",sessionkey:"${localStorage.sessionKey}") { datetime_created,raw_modis_geom,raw_viirs_geom,type,status,companyName,isPeat,isNonRspo,isProtected }}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          console.log(data)
          if (data.getfilteredhotspot.length > 0) { 
              dispatch({ 
                  type: type.GET_FILTERED_HOTSPOT_SUCCESS, 
                  payload: data.getfilteredhotspot,
                  key: guid()
                  });
              
          } else {
            dispatch({ 
                type: type.GET_FILTERED_HOTSPOT_ERROR, 
                payload: 'Error retrieving filtered hotspot',
                key: guid()
                });
          }
          }).catch(error => {
              dispatch({ type: type.GET_FILTERED_HOTSPOT_POST_ERROR, key: guid(), error: error.message });
      });
  };

  

export const fetchTriggeredCSV = (hotspot) => async dispatch => { 
    const query = `query{getfilteredhotspotcsv( dateFrom:"${hotspot.dateFrom}",type:"${hotspot.type}", status:"${hotspot.status}", dateTo:"${hotspot.dateTo}",sessionkey:"${localStorage.sessionKey}") { content }}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.getfilteredhotspotcsv.content !== "") { 
              dispatch({ 
                  type: type.GET_FILTERED_CSV_HOTSPOT_SUCCESS, 
                  payload: data.getfilteredhotspotcsv
                  });
              
          } else {
            dispatch({ 
                type: type.GET_FILTERED_HOTSPOT_ERROR, 
                payload: 'Error retrieving filtered hotspot'
                });
          }
          }).catch(error => {
              dispatch({ type: type.GET_FILTERED_HOTSPOT_POST_ERROR, key: guid(), error: error.message });
      });
  };
   
   
  
export const editUserInfo = (data) => async dispatch => { 
    var str = JSON.stringify(data);
    str = JSON.stringify(str);
    const query = `query{editUserInfoArr( userArr:${str}, sessionkey:"${localStorage.sessionKey}") { success,message }}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.editUserInfoArr.success) { 
              dispatch({ 
                  type: type.EDIT_USER_INFO_SUCCESS, 
                  payload: data.editUserInfoArr
                  });
              
          } else {
            dispatch({ 
                type: type.EDIT_USER_INFO_ERROR, 
                payload: 'Error editing user info'
                });
          }
          }).catch(error => {
              dispatch({ type: type.EDIT_USER_INFO_POST_ERROR, key: guid(), error: error.message });
      });
  };

  
  export const editCompanyInfo = (data) => async dispatch => { 
    var str = JSON.stringify(data);
    str = JSON.stringify(str);
    const query = `query{editCompanyInfoArr( companyArr:${str}, sessionkey:"${localStorage.sessionKey}") { success,message }}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.editCompanyInfoArr.success) { 
              dispatch({ 
                  type: type.EDIT_COMPANY_INFO_SUCCESS, 
                  payload: data.editCompanyInfoArr,
                  key:guid()
                  });
              
          } else {
            dispatch({ 
                type: type.EDIT_COMPANY_INFO_ERROR, 
                payload: 'Error editing company info',
                key:guid()
                });
          }
          }).catch(error => {
              dispatch({ type: type.EDIT_COMPANY_INFO_POST_ERROR, key: guid(), error: error.message });
      });
  };

export const fetchRawViirs = (modis) => async dispatch => { 
    const query = `query{getviirs( dateFrom:"${modis.dateFrom}", dateTo:"${modis.dateTo}",sessionkey:"${localStorage.sessionKey}") { acqdate, acqtime,latitude, longitude,confidence, bright_ti4,bright_ti5,  day_night }}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.getviirs.length > 0) { 
              dispatch({ 
                  type: type.GET_ALL_VIIRS_SUCCESS, 
                  payload: data.getviirs
                  });
              
          } else {
            dispatch({ 
                type: type.GET_ALL_HOTSPOT_VIIRS_ERROR, 
                payload: 'Error retrieving viirs'
                });
          }
          }).catch(error => {
              dispatch({ type: type.GET_ALL_HOTSPOT_VIIRS_POST_ERROR, key: guid(), error: error.message });
      });
  };

  
export const fetchRawNOAA = (modis) => async dispatch => { 
    const query = `query{getviirs( dateFrom:"${modis.dateFrom}", dateTo:"${modis.dateTo}",sessionkey:"${localStorage.sessionKey}") { acqdate, acqtime,latitude, longitude,confidence, bright_ti4,bright_ti5,  day_night }}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.getviirs.length > 0) { 
              dispatch({ 
                  type: type.GET_ALL_NOAA_SUCCESS, 
                  payload: data.getviirs
                  });
              
          } else {
            dispatch({ 
                type: type.GET_ALL_HOTSPOT_NOAA_ERROR, 
                payload: 'Error retrieving NOAA'
                });
          }
          }).catch(error => {
              dispatch({ type: type.GET_ALL_HOTSPOT_NOAA_POST_ERROR, key: guid(), error: error.message });
      });
  };
  
export const fetchNewForm = (enccode, hash) => async dispatch => {
    const query = `query{getEForm( encName:"${enccode}" ,sessionkey:"${localStorage.sessionKey}", h:"${hash}") { encname,  consent, hotspot_id, member_name, hotspot_point, datetime_modified,report_status, data_source, report_title,report_month_year, report_date,officer_names,officer_phones,officer_emails,blob_extensions,officer_positions,incidents,verification_date,subsidiary,estate_name,country,block_field,province_state,area_certified, actual_point, hotspot_date,fire_detected_date,fire_extinguished_date, temperature, humidity, direction, precipitation, soil_type, vegetation_cover,land_cover, isprotected, fire_location, npp, area_burnt_ha, management_action, cause_of_fire, nppType, repeated_fire, remarks, report_status, incident_status,imagesBlob  }}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.getEForm !== null) { 
              console.log(data)
              dispatch({ 
                  type: type.GET_CONC_FORM_SUCCESS, 
                  payload: data.getEForm
                  });
              
          } else {
            dispatch({ 
                type: type.GET_CONC_FORM_ERROR, 
                payload: 'Error retrieving CONCESSION FORM'
                });
          }
          }).catch(error => {
              dispatch({ type: type.GET_CONC_FORM_POST_ERROR, key: guid(), error: error.message });
      });
  };

  
export const fetchEForm = (enccode, hash) => async dispatch => {
    const query = `query{getEForm( encName:"${enccode}" ,sessionkey:"${localStorage.sessionKey}", h:"${hash}") { encname,consent, hotspot_id, member_name, hotspot_point, datetime_modified, report_status, data_source, report_title,report_month_year, report_date,officer_names,officer_phones,officer_emails,officer_positions,incidents,verification_date,subsidiary,estate_name,block_field,province_state,area_certified, actual_point, hotspot_date,fire_detected_date,fire_extinguished_date, temperature, humidity, direction, precipitation, soil_type, vegetation_cover, fire_location, npp, area_burnt_ha, management_action, cause_of_fire, nppType, repeated_fire, remarks, report_status, incident_status,imagesBlob }}`;
      await axios.post(
          API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          if (data.getEForm !== null) { 
              console.log(data)
              dispatch({ 
                  type: type.GET_CONC_FORM_SUCCESS, 
                  payload: data.getEForm
                  });
              
          } else {
            dispatch({ 
                type: type.GET_CONC_FORM_ERROR, 
                payload: 'Error retrieving CONCESSION FORM'
                });
          }
          }).catch(error => {
              dispatch({ type: type.GET_CONC_FORM_POST_ERROR, key: guid(), error: error.message });
      });
  };
  

export const checkfilestatus = (dateFrom, dateTo) => async dispatch => { 
  const query = `query{checkfilestatus( sessionkey:"${localStorage.sessionKey}", dateFrom:"${dateFrom}", dateTo:"${dateTo}") {  date, modis, viirs, status }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(reponse => {
        const data = reponse.data.data;
        if(data.checkfilestatus.length > 0){
            dispatch({ 
                type: type.CHECK_FILE_SUCCESS, 
                payload: data.checkfilestatus
                });
        }
        else
        {
            dispatch({ type: type.CHECK_FILE_ERROR, key: guid(), error:'No Result' });
        }
        }).catch(error => {
            dispatch({ type: type.CHECK_FILE_POST_ERROR, key: guid(), error: error.message });
    });
};

export const downloadViirstoday = () => async dispatch => { 
    const query = `query{triggerviirs( id:0) { message, success }}`;
      await axios.post(
        API_URL2,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
            dispatch({ 
                type: type.DOWNLOAD_HOTSPOT_SUCCESS, 
                payload: data.triggerviirs
                });
          }).catch(error => {
              dispatch({ type: type.DOWNLOAD_HOTSPOT_POST_ERROR, key: guid(), error: error.message });
      });
  };
  
  

export const fetchAllCompany = (filter) => async dispatch => { 
    const query = `query{getallcompany( keyword:"${filter}", sessionkey:"${localStorage.sessionKey}") {id, company_name,company_group{group_name}, reg_no,phone,fax, datetime_created, last_modified,mail_address }}`;
      await axios.post(
        API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
            if(data.getallcompany.length > 0){

                dispatch({ 
                    type: type.GET_ALL_COMPANY_SUCCESS, 
                    payload: data.getallcompany
                    });
            }
            else{
                dispatch({ 
                    type: type.GET_ALL_COMPANY_ERROR, 
                    payload:'Error | No Result'
                    });
            }
          }).catch(error => {
              dispatch({ type: type.GET_ALL_COMPANY_POST_ERROR, key: guid(), error: error.message });
      });
    };


    
export const fetchAllPlantation = (filter) => async dispatch => { 
    const query = `query{getallplantation( cid:${filter}, sessionkey:"${localStorage.sessionKey}") {id, company_group, company_name, plantation_name, datetime_modified,state_name, province_name, mill, area, site,certnum,member_num}}`;
      await axios.post(
        API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
            if(data.getallplantation.length > 0){

                dispatch(fetchAllCountry(''));
                dispatch({ 
                    type: type.PLANTATION_VIEW_SUCCESS, 
                    payload: data.getallplantation
                    });
            }
            else{
                dispatch({ 
                    type: type.PLANTATION_VIEW_ERROR, 
                    payload:'Error | No Result'
                    });

                    dispatch(fetchAllCountry(''));
            }
          }).catch(error => {
              dispatch({ type: type.PLANTATION_VIEW_POST_ERROR, key: guid(), error: error.message });
      });
    };

    
export const fetchAllEmail = (filter) => async dispatch => { 
    const query = `query{getallemail( keyword:"${filter}", sessionkey:"${localStorage.sessionKey}") {datetime_created, title, recipients, template_email, status, formenc}}`;
      await axios.post(
        API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          console.log(data);
            if(data.getallemail.length > 0){

                dispatch({ 
                    type: type.EMAIL_VIEW_SUCCESS, 
                    payload: data.getallemail
                    });
            }
            else{
                dispatch({ 
                    type: type.EMAIL_VIEW_ERROR, 
                    payload:'Error | No Result'
                    });
            }
          }).catch(error => {
              dispatch({ type: type.EMAIL_VIEW_POST_ERROR, key: guid(), error: error.message });
      });
    };

    export const fetchAllCountry = (filter) => async dispatch => { 
        const query = `query{getallcountry( keyword:"${filter}", sessionkey:"${localStorage.sessionKey}") {id, country_name}}`;
          await axios.post(
            API_URL,
              JSON.stringify(getBody(query))
          ).then(reponse => {
              const data = reponse.data.data;
              
                if(data.getallcountry.length > 0){
    
                    dispatch({ 
                        type: type.COUNTRY_VIEW_SUCCESS, 
                        payload: data.getallcountry
                        });
                }
                else{
                    dispatch({ 
                        type: type.COUNTRY_VIEW_ERROR, 
                        payload:'Error | No Result'
                        });
                }
              }).catch(error => {
                  dispatch({ type: type.COUNTRY_VIEW_POST_ERROR, key: guid(), error: error.message });
          });
        };
    
    
export const editEmail = (status) => async dispatch => { 
    const query = `query{modifyEmail( status:"${status}", sessionkey:"${localStorage.sessionKey}") {success, message}`;
      await axios.post(
        API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
            if(data.modifyEmail.success){

                dispatch({ 
                    type: type.EMAIL_EDIT_SUCCESS, 
                    payload: data.modifyEmail.message
                    });
            }
            else{
                dispatch({ 
                    type: type.EMAIL_EDIT_ERROR, 
                    payload: data.modifyEmail.message
                    });
            }
          }).catch(error => {
              dispatch({ type: type.EMAIL_VIEW_POST_ERROR, key: guid(), error: error.message });
      });
    };
    
    
export const changeUserStat = (filter) => async dispatch => { 
    const query = `query{changeUserStatus( uid:"${filter}", sessionkey:"${localStorage.sessionKey}") {success, message }}`;
      await axios.post(
        API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          console.log(data);
            if(data.changeUserStatus.success ){
                dispatch({ 
                    type: type.EDIT_USER_INFO_SUCCESS, 
                    payload: data.changeUserStatus
                    });
            }
            else{
                dispatch({ 
                    type: type.EDIT_USER_INFO_ERROR, 
                    payload:'Error | No Result'
                    });
            }
          }).catch(error => {
              dispatch({ type: type.EDIT_USER_INFO_POST_ERROR, key: guid(), error: error.message });
      });
    };
    

export const fetchAllUsers = (filter) => async dispatch => { 
    const query = `query{getalluser( keyword:"${filter}", sessionkey:"${localStorage.sessionKey}") {company, username, datetime_created ,email, status  }}`;
      await axios.post(
        API_URL,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          console.log(data);
            if(data.getalluser.length > 0){
                dispatch({ 
                    type: type.GET_ALL_USERS_SUCCESS, 
                    payload: data.getalluser
                    });
            }
            else{
                dispatch({ 
                    type: type.GET_ALL_USERS_ERROR, 
                    payload:'Error | No Result'
                    });
            }
          }).catch(error => {
              dispatch({ type: type.GET_ALL_USERS_POST_ERROR, key: guid(), error: error.message });
      });
    };
    
    export const createNewUser = (data) => async dispatch => { 
        const query = `query{createuser(cid: ${data.cid} , username:"${data.username}",pw:"${data.pw}",email:"${data.email}" , sessionkey:"${localStorage.sessionKey}") { success,message }}`;
          await axios.post(
            API_URL,
              JSON.stringify(getBody(query))
          ).then(reponse => {
              const data = reponse.data.data;
              if(data.createuser.success){
                dispatch({ 
                    type: type.NEW_USER_SUCCESS, 
                    payload: data.createuser
                    });
                }
                 
                else{
                    dispatch({ 
                        type: type.GET_ALL_USERS_ERROR, 
                        payload:'Error | No Result'
                        });
                }
              }).catch(error => {
                  dispatch({ type: type.GET_ALL_USERS_POST_ERROR, key: guid(), error: error.message });
          });
        };
  

        export const createNewPlantation= (data) => async dispatch => { 
            const query = `query{createplantation(cid:"${data.cid}" , pname:"${data.newPlantationName}",site:"${data.site}",mill:"${data.mill}",pmttype:"${data.pmttype}",pmtdate:"${data.pmtdate}",pmtnum:"${data.pmtnum}", area:${data.area}, certdate:"${data.certdate}", certnum:"${data.certnum}", member_num:"${data.member_num}", member_year:${data.member_year}, state_name:"${data.state_name}", province_name:"${data.province_name}", country_id:${data.country_id},  sessionkey:"${localStorage.sessionKey}") { success,message }}`;
              await axios.post(
                API_URL,
                  JSON.stringify(getBody(query))
              ).then(reponse => {
                  const data = reponse.data.data;
                  if(data.createplantation.success){
                    dispatch({ 
                        type: type.CREATE_PLANTATION_SUCCESS, 
                        payload: data.createplantation
                        });
                    }
                     
                    else{
                        dispatch({ 
                            type: type.CREATE_PLANTATION_ERROR, 
                            payload:data.createplantation
                            });
                    }
                  }).catch(error => {
                      dispatch({ type: type.CREATE_PLANTATION_POST_ERROR, key: guid(), error: error.message });
              });
            };
      

    export const createNewComp = (data) => async dispatch => { 
        const query = `query{createcompany(gname:"${data.companyGroup}" , cname:"${data.companyName}",regNo:"${data.regNo}",phone:"${data.phone}",fax:"${data.fax}",mailAddress:"${data.mailAddress}", sessionkey:"${localStorage.sessionKey}") { success,message }}`;
          await axios.post(
            API_URL,
              JSON.stringify(getBody(query))
          ).then(reponse => {
              const data = reponse.data.data;
              if(data.createcompany.success){
                dispatch({ 
                    type: type.NEW_COMPANY_SUCCESS, 
                    payload: data.createcompany
                    });
                }
                 
                else{
                    dispatch({ 
                        type: type.GET_ALL_COMPANY_ERROR, 
                        payload:data.createcompany
                        });
                }
              }).catch(error => {
                  dispatch({ type: type.GET_ALL_COMPANY_POST_ERROR, key: guid(), error: error.message });
          });
        };
  
        

export const downloadModistoday = () => async dispatch => { 
    const query = `query{triggermodis( id:0) { message, success }}`;
      await axios.post(
        API_URL2,
          JSON.stringify(getBody(query))
      ).then(reponse => {
          const data = reponse.data.data;
          dispatch({ 
            type: type.DOWNLOAD_HOTSPOT_SUCCESS, 
            payload: data.triggermodis
            }); 
          }).catch(error => {
              dispatch({ type: type.DOWNLOAD_HOTSPOT_POST_ERROR, key: guid(), error: error.message });
      });
  };
  

export const checkUserRole = () => async dispatch => {
  const sk = getSessionKey();
  if (!sk) {
    dispatch({ type: type.CHECK_ROLE_ERROR, payload: { status: false, message: 'Session expired. Please log in again.' }, key: guid() });
    return;
  }
  const query = `query{checkuser( sessionkey:"${sk}") { role_id, sessionkey, status, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        const userRoles = [];
        console.log(data);
//        console.log("checkuser");
   //     console.dir(data.checkuser);
  //      console.log("checkuser");
            if(data.checkuser !== null)
            if(data.checkuser.length > 0)
            if (data.checkuser[0].status) {
                for (var r = 0; r < data.checkuser.length; r++) {
                    if (data.checkuser[r].status) {
                        userRoles.push(data.checkuser[r].role_id);
                    }
                }
                dispatch({ 
                    type: type.CHECK_ROLE_SUCCESS, 
                    payload: userRoles,
                    key: guid() });
                // Redirect
            } else { 
                if(data.checkuser !== null)
            if(data.checkuser.length > 0) 
            {
                var error = {
                    status : data.checkuser[0].status,
                    message : data.checkuser[0].message
                }
                 dispatch({ 
                type: type.CHECK_ROLE_ERROR, 
                payload: error,
                key: guid() });
                 }
                //dispatch({ type: type.LOGIN_ERROR, payload: data.checkuser[r].message });
            }
    }).catch(error => {
        console.log(error);
    });
};

export const fetchData = () => async dispatch => {
  const res = await axios.get(`${SW_API_URL}/people`);
  dispatch({
    type: type.FETCH_DATA,
    payload: res.data.results
  });
};



export const createProject = (projname) => async dispatch => {
    var js = {
            "ProjectInfo":{
            "ProjectName":`${projname}`,
            "ViewStyle":{
                "mapCenter": [11313087.85346717,344195.92631600494],
                "ZoomLevel": 13.5,
                "mapExtent": [],
                "bufferSize":3.142,
                
            },
            "ViewLayer":{
                "Layers":[],
                "layerON": [],
                "identifyLayer": "",
                "styles":[]
            },
            "Component":{
                "SwitchOn":[],
                "Overlay":{
                    "Notes":[],
                    "Measurements":{
                        "Measures":[]
                    },
                    "Drawings":{
                        "Drawings":[]
                    }
                }
            }
        }
    };  
    js = JSON.stringify(js) ;
       js = JSON.stringify(js);
    //js = JSON.stringify(js);
    console.log(js)
    /*
{\\"ProjectInfo\\": {\\"ProjectName\\": \\"${projname}\\",\\"ViewStyle\\": {\\"mapCenter\\": \\"[11313087.85346717,344195.92631600494]\\",\\"ZoomLevel\\": 13.5,\\"mapExtent\\": \\"[]\\",\\"bufferSize\\": 3.142,\\"Tooltip\\": true,\\"ToolTipON\\": \\"[]\\" },
    \\"ViewLayer\\": {\\"layerON\\": \\"[]\\",\\"identifyLayer\\": \\"\\", \\"styles\\":\\"[]\\"},\\"Component\\": {\\"SwitchOn\\": \\"[]\\",\\"Overlay\\": {\\"Notes\\": \\"[]\\"},\\"Measurements\\": {\\"Measures\\": \\"[]\\"},\\"Drawings\\": {\\"Drawings\\": \\"[]\\"}}} }
    */
    const query = `query{savenewproject(projname:"${projname}",setting:`+js+`,sessionKey:"${localStorage.getItem("sessionKey")}"){message,success}}`;
    
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.savenewproject != null) {
            if (data.savenewproject.length > 0){
                if (data.savenewproject[0].message === type.SESSION_INVALID) {
                    localStorage.setItem("sessionKey", "");
                    history.push("/signIn");
                } else {
                    if(data.savenewproject[0].success)
                    {
                         
        dispatch(fetchProject('active'));
                    }
                   /* return dispatch({
                        type: type.PROJECTLIST_SUCCESS,
                        payload: data.savenewproject,
                        key: guid(),
                    });*/
             }
            }

        } 
        
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
    });
}

export const fetchProject = (status) => async dispatch => {
    const query = `query{getprojectlist(status:"${status}",sessionKey:"${localStorage.getItem("sessionKey")}"){signature,status,project_name,datetime_created, message, success}}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        console.log(data);
        if (data.getprojectlist != null) {
            if (data.getprojectlist.length > 0){
                if (data.getprojectlist[0].message === type.SESSION_INVALID) {
                    localStorage.setItem("sessionKey", "");
                    history.push("/signIn");
                } else {
                    
                    dispatch(checkUserRole());
                    dispatch(getNotExpiredPackages());
                    return dispatch({
                        type: type.PROJECTLIST_SUCCESS,
                        payload: data.getprojectlist,
                        message: data.getprojectlist.message,

                        key: guid(),
                    });
                }
            }

        } 
        
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
    });
}

export const fetchUser = (keyword, offset, limit) => async dispatch => {
    const query = `query{selectuserwithwithoutpackagepaginate( keyword:"${keyword}",offset:${offset},limit:${limit},sessionKey:"${localStorage.getItem("sessionKey")}") { id, username, status, datetime_created, pw_modified, lastlogin, login_ip, accessibility_user_id, message }}`;
    const res = await axios.post(
        API_URL,
        JSON.stringify(getBody(query, { ip: "1.1.1.1" }))
    );
    const data = res.data.data;
    if (data.selectuserwithwithoutpackagepaginate[0].message === type.SESSION_INVALID) {
        localStorage.setItem("sessionKey", "");
        history.push("/signIn");
    } else {
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        dispatch(countuser(keyword));
        return dispatch({
            type: type.FETCH_USER_SUCCESS,
            payload: data.selectuserwithwithoutpackagepaginate,
            key: guid(),
        });
    }
};

export const fetchMainUser = (keyword, offset, limit) => async dispatch => {
    const query = `query{selectmainuserpaginate( keyword:"${keyword}",offset:${offset},limit:${limit},sessionKey:"${localStorage.getItem("sessionKey")}") { id, username, status, datetime_created, pw_modified, lastlogin, login_ip, accessibility_user_id, message }}`;
    const userList = [];
    const res = await axios.post(
        API_URL,
        JSON.stringify(getBody(query, { ip: "1.1.1.1" }))
    ).catch(error => {
        console.log(error);
        });
    const data = res.data.data;
    if (data != null) {
        if (data.selectmainuserpaginate[0].message === type.SESSION_INVALID) {
            localStorage.setItem("sessionKey", "");
            history.push("/signIn");
        } else {
            if (limit == 0) {
                for (var i = 0; i < data.selectmainuserpaginate.length; i++) {
                    userList.push({ label: data.selectmainuserpaginate[i].username });
                }
            }
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            dispatch(countmainuser(keyword));
            return dispatch({
                type: type.FETCH_MAIN_USER_SUCCESS,
                payload: data.selectmainuserpaginate,
                key: guid(),
                userArray: userList
            });
        }
    } else {
        console.log("here");
    }
    
};

export const fetchPlainUser = (keyword, offset, limit) => async dispatch => {
    const query = `query{selectplainuserpaginate( keyword:"${keyword}",offset:${offset},limit:${limit},sessionKey:"${localStorage.getItem("sessionKey")}") { id, username, status, datetime_created, pw_modified, lastlogin, login_ip, accessibility_user_id, message }}`;
    const res = await axios.post(
        API_URL,
        JSON.stringify(getBody(query, { ip: "1.1.1.1" }))
    );
    const data = res.data.data;
    if (data.selectplainuserpaginate.length > 0) {
        if (data.selectplainuserpaginate[0].message === type.SESSION_INVALID || data.selectplainuserpaginate[0].message === type.DDOS_SUSPECTED) {
            localStorage.setItem("sessionKey", "");
            history.push("/signIn");
        }
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        return dispatch({
            type: type.FETCH_PLAIN_USER_SUCCESS,
            payload: data.selectplainuserpaginate,
            key: guid(),
        });
    }
};

export const linkUser = (parentUsername, userId, keyword, limit, offset) => async dispatch => {
    const query = `query{linkuser(parentUsername:"${parentUsername}",userId:${userId},sessionKey: "${localStorage.getItem("sessionKey")}") { message, success }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.linkuser.success) {
            dispatch(countplainuser(keyword));
            dispatch(fetchPlainUser(keyword, limit, offset));
            dispatch({
                type: type.LINK_USER_SUCCESS,
                payload: data.linkuser,
                key: guid()
            });
        } else {
            if (data.linkuser.message === SESSION_INVALID || data.linkuser.message === DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.LINK_USER_ERROR,
                payload: data.linkuser,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.LINK_USER_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const registerSubUser = (user, history) => async dispatch => {
    const {
        username,
        password,
        email,
        contact,
        id,
        keyword,
        limit,
        offset
    } = user;
    const query = `query{insertsubuser(parentId:${id},username:"${username}",password:"${password}",phone:"${contact}",mailAddress:"${email}",sessionKey: "${localStorage.getItem("sessionKey")}") { message, success }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.insertsubuser.success) {
            dispatch({
                type: type.REGISTER_SUB_USER_SUCCESS,
                payload: data.insertsubuser,
                key: guid()
            });
        } else {
            if (data.insertsubuser.message === SESSION_INVALID || data.insertsubuser.message === DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.REGISTER_SUB_USER_ERROR,
                payload: data.insertsubuser,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.REGISTER_SUB_USER_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const registerPackage = (user, history) => async dispatch => {
    const {
        description,
        expiryDay,
        packageList,
        type,
        id,
        keyword,
        offset,
        limit,
        username,
    } = user;
    const query = `query{insertregisterpackage(sessionkey: "${localStorage.getItem("sessionKey")}",username:"${username}",packagelist:"[${packageList}]",description:"${description}",type:"${type}",userid:${id},parentid:0,expiryday:${expiryDay}) { message, success }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.insertregisterpackage.success) {
            dispatch(fetchUser(keyword, offset, limit));
            dispatch({
                type: REGISTER_PACKAGE_SUCCESS,
                payload: "you have succesfully signed up. sign in to get started",
                key: guid()
            });
        } else {
            if (data.insertregisterpackage[0].message === SESSION_INVALID || data.insertregisterpackage[0].message === DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: REGISTER_PACKAGE_ERROR,
                payload: data.insertregisterpackage.message,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: REGISTER_PACKAGE_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};


export const checkPackage = () => async dispatch => {
    const query = `query{selectpackagebyapikey( sessionkey: "${localStorage.getItem("sessionKey")}", apikey:"${localStorage.getItem("apiKey")}" ) { packagename, expiry, success, message}}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.selectpackagebyapikey.length > 0)
        {
            if (data.selectpackagebyapikey[0].message === SESSION_INVALID || data.selectpackagebyapikey[0].message === DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch({
                    type: type.GET_ALL_PACKAGE_SUCCESS,
                    payload: data.selectpackagebyapikey,
                    key: guid()
                });
            }
        } else {
            dispatch(checkUserRole());
            dispatch({
                type: type.GET_ALL_PACKAGE_SUCCESS,
                payload: data.selectpackagebyapikey,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.CHECK_PACKAGE_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};
/*
export const handleUpload =(finalQ) =>async dispatch =>{
 await axios({
        method: 'post',
        url: API_URL,
        data: finalQ,
        headers:{'Access-Control-Allow-Origin':'*'},
        timeout:45000,
        maxContentLength: 72428890,
        'Content-Encoding': 'gzip'
      }).then( response => {
        console.log(response);
        if (response.data.data.insertuploadfile.success) {
            dispatch({ type: type.UPLOAD_SUCCESS, payload: response.data.data.insertuploadfile.message });
        } else {
            if (response.data.data.insertuploadfile.message == type.SESSION_INVALID || response.data.data.insertuploadfile.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({ type: type.UPLOAD_ERROR, payload: response.data.data.insertuploadfile.message });
        }
    }).catch(error => {
        console.log(finalQ);
        console.log(error);
        dispatch({
            type: type.UPLOAD_POST_ERROR,
            payload: []
        });
    });
}
*/


export const uploadTiff = (uuser, finalDesc) => async dispatch=>   {
    console.log(uuser)
    console.log(finalDesc)
    const { fileBase } = uuser;
    var fileName = fileBase.name;
    var fileSize = fileBase.size;
   
    var lname =  finalDesc.map(a => a.layername.toString());
    var tiffname =  finalDesc.map(a => a.tiffname.toString());
       
    console.log(lname); 
    console.log(tiffname); 
    let that = this;
    getBase64(uuser.fileBase, function (result) {
        const query = "query{uploadtiff( zname:\"" + fileName + "\", lname: "+ JSON.stringify(lname) + ", b64:\"" + result + "\",  fsize:" + fileSize + ", apikey:\""+localStorage.getItem("apiKey") +"\", tiffname:" + JSON.stringify(tiffname) + ", sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success }}";
        const finalQuery = JSON.stringify(getBody(query));
        
     
        axios.post(API_URL, finalQuery/*,{
            headers:{'Access-Control-Allow-Origin':'*',
            'Content-Type': 'application/json'},
            timeout:45000,
            maxContentLength: 72428890}*/
            ).then( (res) =>{ 
                const data = res.data.data;
                console.log(res);
                try {
                    dispatch({
                        type: type.UPLOAD_TIFF_SUCCESS,
                        payload: 'Success',//data.insertuploadfile.message,
                        });
                    } catch (error) {
                        console.log(error);
                        dispatch({ type: type.UPLOAD_TIFF_ERROR, payload: [],/*data.insertuploadfile.message*/ });
                    }
                 }) });
       // resolve(finalQuery);
    };


    

    export const uploadgeom = (data) => async dispatch=>   { 
        // var fileName = fileBase.name;
        // var fileSize = fileBase.size;
         let that = this; 
         
         
         (async function sending() {  
     
           
            let r = data.fileArr;
            var str = JSON.stringify(r);
            str = JSON.stringify(str);
            const query = `query{uploadgeomfile( pid:${data.pid},  fileArr:${str}) { message, success }}`;
            const finalQuery = JSON.stringify(getBody(query));
            axios.post(API_URL, finalQuery 
                ).then( (res) =>{ 
                    const data = res.data.data;
                    console.log(res);
                    try {
                        dispatch({
                            type: type.UPLOAD_SUCCESS,
                            payload: 'Success',//data.insertuploadfile.message,
                            });
                        } catch (error) {
                            console.log(error);
                            dispatch({ type: type.UPLOAD_ERROR, payload: [],/*data.insertuploadfile.message*/ 
                          });
                        }
                     } ); 
                     
        })();
     
     
        
     };

export const upload = (data) => async dispatch=>   { 
   // var fileName = fileBase.name;
   // var fileSize = fileBase.size;
    let that = this; 
    (async function loop() {
        for (let i = 0; i <data.fileArr.files.length; i++) {
            let d = data.fileArr.files[i];
            await new Promise(resolve => {
                getBase64(data.fileArr.files[i], function (result) {
                    resolve(result);
                })
                
            }).then(res=>{
                
            data.fileArr.base64.push(res);
            data.fileArr.name.push(d.name);
            data.fileArr.size.push(d.size);
            data.fileArr.extension.push(d.type);
            }); 

            
        }
        let r = data.fileArr;
        (async function sending() {  

            var str = JSON.stringify(r);
            str = JSON.stringify(str);
            const query = `query{uploadfile( fid:\"${data.fid}\", referral:\"${data.referral}\",  fileArr:${str}) { message, success }}`;
            const finalQuery = JSON.stringify(getBody(query));
            axios.post(API_URL, finalQuery 
                ).then( (res) =>{ 
                    const data = res.data.data;
                    console.log(res);
                    try {
                        dispatch({
                            type: type.UPLOAD_SUCCESS,
                            payload: 'Success',//data.insertuploadfile.message,
                            });
                        } catch (error) {
                            console.log(error);
                            dispatch({ type: type.UPLOAD_ERROR, payload: [],/*data.insertuploadfile.message*/ 
                          });
                        }
                     } ); 
    
        })();
    })();

     


   
};
   /* let promise = new Promise(function(resolve, reject) {
        /*parseFile(uuser.fileBase, function (result) {
            const query = "query{insertuploadfile( userId:1, fileName:\"" + fileName + "\", fileBlob:\"" + result + "\", filePath:\"D:" + fileName + "\", fileSize:" + fileSize + ", username:\"" + localStorage.getItem("username") + "\", sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success }}";
            const finalQuery = JSON.stringify(getBody(query));
            resolve(finalQuery);
        });*/
 /*       
        
    });*/
   
        /*
    promise.then(
        result =>   {console.log(result); 
            let promise2 = new Promise(function(resolve, reject) { 
               resolve( 
                  
            promise2.then(
                result =>{
                    console.log(result); 
                       
                }
            )
        });
   */
          //  const  res = async(await axios.post(API_URL, result));
           
  

           /* axios({
            method: 'post',
            url: API_URL,
            data: result,
            headers:{'Access-Control-Allow-Origin':'*'},
            timeout:45000,
            maxContentLength: 72428890,
            'Content-Encoding': 'gzip'
          }).then( response => {
            console.log(response);
            if (response.data.data.insertuploadfile.success) {
                dispatch({ type: type.UPLOAD_SUCCESS, payload: response.data.data.insertuploadfile.message });
            } else {
                if (response.data.data.insertuploadfile.message == type.SESSION_INVALID || response.data.data.insertuploadfile.message == type.DDOS_SUSPECTED) {
                    localStorage.setItem("sessionKey", "");
                    history.push("/signIn");
                }
                dispatch({ type: type.UPLOAD_ERROR, payload: response.data.data.insertuploadfile.message });
            }
        }).catch(error => {
            
            console.log(error);
            dispatch({
                type: type.UPLOAD_POST_ERROR,
                payload: []
            });
        });
    })

};*/


export const submitForm = (dat) => async dispatch => {
    console.log(dat);
    var str = JSON.stringify(dat.form);
    var str2 = JSON.stringify(dat.images); 
    var fileStr = JSON.stringify(dat.files); 
    str = JSON.stringify(str);
    str2 = JSON.stringify(str2); 
    fileStr = JSON.stringify(fileStr); 
    const query = "query{sform( fileId:\"" + dat.fId + "\",form:" + str + ",files:" + fileStr +" , img:" + str2 +" ,referral :\"" + dat.referral + "\",sessionkey: \"" + localStorage.getItem("sessionKey") + "\") { message, success}}";
    const res = await axios.post(API_URL, JSON.stringify(getBody(query)));
    const data = res.data.data;
    try 
    {
         if (data.sform.success) {
            dispatch({
                type: type.SUBMIT_CONC_FORM_SUCCESS,
                payload: data.sform,
                });
        }
        else{
            dispatch({
                type: type.SUBMIT_CONC_FORM_ERROR,
                payload: "ERROR IN SUBMISSION" + data.sform.message,
                });
        } 
      
    } catch (error) {
        dispatch({
            type: type.SUBMIT_CONC_FORM_POST_ERROR,
            payload: error
        });
    }
    };


export const download = (fileId) => async dispatch => {
    const query = "query{downloadfile( fileId:" + fileId + ",sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success, downloadfile, fname }}";
    const res = await axios.post(API_URL, JSON.stringify(getBody(query)));
    const data = res.data.data;
    try {
        dispatch({
            type: type.DOWNLOAD_SUCCESS,
            payload: data.downloadfile,
            });
        } catch (error) {
            dispatch({
                type: type.DOWNLOAD_POST_ERROR,
                payload: data.downloadfile,
            });
        }
};


export const publishFile = (fileId) => async dispatch => {
    const query = "query{publish( fileId:" + fileId + ",sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success, fname, fsize }}";
    const res = await axios.post(API_URL, JSON.stringify(getBody(query)));
    const data = res.data.data;
    try {
        dispatch({
            type: type.DOWNLOAD_SUCCESS,
            payload: data.downloadfile.file,
            });
        } catch (error) {
            console.log(error);
        }
};

export const updateuserstoactive = (userIds, keyword, offset, limit) => async dispatch => {
    const query = "query{updateuserstoactive( userIds:\"[" + userIds + "]\", username:\"admin\", sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.updateuserstoactive.success) {
                dispatch(fetchUser(keyword, offset, limit));
                dispatch({
                    type: type.UPDATE_USERS_TO_ACTIVE_SUCCESS,
                    payload: data.updateuserstoactive.success,
                    key: guid()
                });
        } else {
            if(data.updateuserstoactive.message == type.SESSION_INVALID || data.updateuserstoactive.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(fetchUser(keyword, offset, limit));
            dispatch({
                type: type.UPDATE_USERS_TO_ACTIVE_ERROR,
                payload: data.updateuserstoactive.success,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.UPDATE_USERS_TO_ACTIVE_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const updateuserstoinactive = (userIds, keyword, offset, limit) => async dispatch => {
    const query = "query{updateuserstoinactive( userIds:\"[" + userIds + "]\", username:\"admin\", sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.updateuserstoinactive.success) {
            dispatch(fetchUser(keyword, offset, limit));
            dispatch({
                type: type.UPDATE_USERS_TO_INACTIVE_SUCCESS,
                payload: data.updateuserstoinactive.success,
                key: guid()
            });
        } else {
            if(data.updateuserstoinactive.message == type.SESSION_INVALID || data.updateuserstoinactive.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(fetchUser(keyword, offset, limit));
            dispatch({
                type: type.UPDATE_USERS_TO_INACTIVE_ERROR,
                payload: data.updateuserstoinactive.success,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.UPDATE_USERS_TO_INACTIVE_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const countuser = (keyword) => async dispatch => {
    const query = "query{selectcountuser( keyword:\"" + keyword + "\"sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { count, message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.selectcountuser.success) {
            dispatch({
                type: type.COUNT_USER_SUCCESS,
                payload: data.selectcountuser.success,
                count: data.selectcountuser.count
            });
        } else {
            if (data.selectcountuser.message == type.SESSION_INVALID || data.selectcountuser.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.COUNT_USER_ERROR,
                payload: data.selectcountuser.success
            });
        }
    }).catch(error => {
        dispatch({
            type: type.COUNT_USER_POST_ERROR,
            payload: []
        });
    });
};

export const countmainuser = (keyword) => async dispatch => {
    const query = "query{selectcountmainuser( keyword:\"" + keyword + "\"sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { count, message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.selectcountmainuser.success) {
            dispatch({
                type: type.COUNT_MAIN_USER_SUCCESS,
                payload: data.selectcountmainuser.success,
                count: data.selectcountmainuser.count
            });
        } else {
            if (data.selectcountmainuser.message == type.SESSION_INVALID || data.selectcountmainuser.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.COUNT_MAIN_USER_ERROR,
                payload: data.selectcountmainuser.success
            });
        }
    }).catch(error => {
        dispatch({
            type: type.COUNT_MAIN_USER_POST_ERROR,
            payload: []
        });
    });
};

export const countplainuser = (keyword) => async dispatch => {
    const query = "query{selectcountplainuser( keyword:\"" + keyword + "\"sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { count, message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.selectcountplainuser.success) {
            dispatch({
                type: type.COUNT_PLAIN_USER_SUCCESS,
                payload: data.selectcountplainuser.success,
                count: data.selectcountplainuser.count
            });
        } else {
            if (data.selectcountplainuser.message == type.SESSION_INVALID || data.selectcountplainuser.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.COUNT_PLAIN_USER_ERROR,
                payload: data.selectcountplainuser.success
            });
        }
    }).catch(error => {
        dispatch({
            type: type.COUNT_PLAIN_USER_POST_ERROR,
            payload: []
        });
    });
};

export const countpublishlayerview = (keyword, fromDate, toDate) => async dispatch => {
    const query = `query{countpublishlayerview(keyword:"${keyword}", fromDate:"${fromDate}", toDate:"${toDate}", apiKey:"${localStorage.getItem("apiKey")}", sessionKey:"${localStorage.getItem("sessionKey")}") { count, success, message }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.countpublishlayerview.success) {
            dispatch({
                type: type.COUNT_PUBLISH_LAYER_VIEW_SUCCESS,
                payload: data.countpublishlayerview.success,
                count: data.countpublishlayerview.count
            });
        } else {
            if (data.countpublishlayerview.message == type.SESSION_INVALID || data.countpublishlayerview.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.COUNT_PUBLISH_LAYER_VIEW_ERROR,
                payload: data.countpublishlayerview.success
            });
        }
    }).catch(error => {
        dispatch({
            type: type.COUNT_PUBLISH_LAYER_VIEW_POST_ERROR,
            payload: []
        });
    });
};

export const countRequestUpdatePublishUri = (keyword) => async dispatch => {
    const query = `query{countrequestupdatepublishuri(keyword:"${keyword}", status:"pending", sessionKey:"${localStorage.getItem("sessionKey")}") { count, success, message }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.countrequestupdatepublishuri.success) {
            dispatch({
                type: type.COUNT_REQUEST_UPDATE_PUBLISH_URI_SUCCESS,
                payload: data.countrequestupdatepublishuri.success,
                count: data.countrequestupdatepublishuri.count
            });
        } else {
            if (data.countrequestupdatepublishuri.message == type.SESSION_INVALID || data.countrequestupdatepublishuri.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.COUNT_REQUEST_UPDATE_PUBLISH_URI_ERROR,
                payload: data.countrequestupdatepublishuri.success
            });
        }
    }).catch(error => {
        dispatch({
            type: type.COUNT_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR,
            payload: []
        });
    });
};

export const fetchFile = (keyword, offset, limit) => async dispatch => {
    const query = `query{selectuploadfilebyuserpaginate(keyword:"${keyword}", offset:${offset}, limit:${limit}, sessionKey:"${localStorage.getItem("sessionKey")}") { id, file_name, file_size, status, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.selectuploadfilebyuserpaginate.length > 0)
        {
            if (data.selectuploadfilebyuserpaginate[0].message === type.SESSION_INVALID || data.selectuploadfilebyuserpaginate[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/files");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch(countFile(keyword));
                return dispatch({
                    type: type.FETCH_FILE_SUCCESS,
                    payload: data.selectuploadfilebyuserpaginate,
                    key: guid()
                });
            }
        }
        else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            dispatch(countFile(keyword));
            return dispatch({
                type: type.FETCH_FILE_SUCCESS,
                payload: data.selectuploadfilebyuserpaginate,
                key: guid()
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.FETCH_FILE_POST_ERROR,
            payload: []
        });
    });
};

export const countFile = (keyword) => async dispatch => {
    const query = "query{countuploadfilebyuser( keyword: \"" + keyword +"\",sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { count, message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.countuploadfilebyuser.success) {
            return dispatch({
                type: type.COUNT_FILE_SUCCESS,
                payload: data.countuploadfilebyuser.success,
                count: data.countuploadfilebyuser.count
            });
        } else {
            if (data.countuploadfilebyuser.message == type.SESSION_INVALID || data.countuploadfilebyuser.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            return dispatch({
                type: type.COUNT_FILE_ERROR,
                payload: data.countuploadfilebyuser.success
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.COUNT_FILE_POST_ERROR,
            payload: []
        });
    });
};

export const filePublishRemove = (fileId, action, keyword, offset, limit) => async dispatch => {
    var query = '';
    if(action)
    {
        query = `query{publish( fileId:${fileId}, action:"${action}",sessionKey:"${localStorage.getItem("sessionKey")}") { success, message }}`;
    }
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.publish.message === type.SESSION_INVALID || data.publish.message === type.DDOS_SUSPECTED) {
            localStorage.setItem("sessionKey", "");
            history.push("/files");
        } else {
            dispatch(fetchFile(keyword, offset, limit));
            return dispatch({
                type: type.FILE_PUBLISH_REMOVE_SUCCESS,
                payload: data.publish,
                key: guid(),
                userAction: action
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.FILE_PUBLISH_REMOVE_POST_ERROR,
            payload: []
        });
    });
};

export const fetchLayer = (keyword, offset, limit) => async dispatch => {
    const query = `query{selectlayerjoinportrayalbystatusandownloginpaginate( keyword:"${keyword}",offset:${offset},limit:${limit},sessionKey:"${localStorage.getItem("sessionKey")}") { layer_id, layer_name, user_id, layer_order, status, file_path, external_link, publish_uri, datetime_created, file_id, portrayer_id, portrayer_owner_userid, portrayer_to_user_id, portrayer_layer_name, portrayer_layer_order, portrayer_status, portrayer_datetime_created, portrayer_layer_id, portrayer_username, publish_uri_id, publish_uri_owner_user_id, publish_uri_layer_id, publish_uri_link, publish_uri_category, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.selectlayerjoinportrayalbystatusandownloginpaginate.length > 0)
        {
            if (data.selectlayerjoinportrayalbystatusandownloginpaginate[0].message === type.SESSION_INVALID || data.selectlayerjoinportrayalbystatusandownloginpaginate[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/layers");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch(countLayer(keyword));
                return dispatch({
                    type: type.FETCH_LAYER_SUCCESS,
                    payload: data.selectlayerjoinportrayalbystatusandownloginpaginate,
                    key: guid()
                });
            }
        } else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            dispatch(countLayer(keyword));
            return dispatch({
                type: type.FETCH_LAYER_SUCCESS,
                payload: data.countlayerjoinportrayalbystatusandownloginpaginate
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.FETCH_LAYER_POST_ERROR,
            payload: []
        });
    });
};

export const fetchTiffLayer = (keyword, offset, limit) => async dispatch => {
    const query = `query{getTiff( keyword:"${keyword}",offset:${offset},limit:${limit},sessionKey:"${localStorage.getItem("sessionKey")}") { encname, status, layer_name, tiff_name, datetime_created }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data; 
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        if (data.getTiff.length > 0)
        {
            return dispatch({
                type: type.TILE_TIFF_RETRIEVE_SUCCESS,
                payload: data.getTiff
            });
        } else {
            
            return dispatch({
                type: type.TILE_TIFF_ERROR,
                payload: 'Error'
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.TILE_TIFF_POST_ERROR,
            payload: []
        });
    });
};


export const tileThis = (keyword) => async dispatch => {
    const query = `query{tileThis( encname:"${keyword}",sessionKey:"${localStorage.getItem("sessionKey")}") { message,success }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data; 
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        if(data.tileThis.success){
            dispatch(fetchTiffLayer('untiled',0,0));
            return dispatch({
                type: type.TILE_TIFF_SUCCESS,
                payload: data.tileThis.message
            });
            
        }
        else{
            return dispatch({
                type: type.TILE_TIFF_ERROR,
                payload: data.tileThis.message
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.TILE_TIFF_POST_ERROR,
            payload: []
        });
    });
};

export const countLayer= (keyword) => async dispatch => {
    const query = "query{countlayerjoinportrayalbystatusandownlogin( keyword: \"" + keyword + "\",sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { count, message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.countlayerjoinportrayalbystatusandownlogin.success) {
            return dispatch({
                type: type.COUNT_LAYER_SUCCESS,
                payload: data.countlayerjoinportrayalbystatusandownlogin.success,
                count: data.countlayerjoinportrayalbystatusandownlogin.count
            });
        } else {
            if (data.countlayerjoinportrayalbystatusandownlogin.message == type.SESSION_INVALID || data.countlayerjoinportrayalbystatusandownlogin.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            return dispatch({
                type: type.COUNT_LAYER_ERROR,
                payload: data.countlayerjoinportrayalbystatusandownlogin.success,
                count: []
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.COUNT_LAYER_POST_ERROR,
            payload: [],
            count: []
        });
    });
};

export const fetchPortrayLayer = () => async dispatch => {
    const query = `query{selectportraylayersbytouserid( username:"admin",touserid:97,sessionKey:"${localStorage.getItem("sessionKey")}") { id, file_name, file_size, status, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.selectportraylayersbytouserid[0].message === type.SESSION_INVALID || data.selectportraylayersbytouserid[0].message === type.DDOS_SUSPECTED) {
            localStorage.setItem("sessionKey", "");
            history.push("/signIn");
        } else {
            return dispatch({
                type: type.FETCH_PORTRAYLAYER_SUCCESS,
                payload: data.selectportraylayersbytouserid,
                key: guid()
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.FETCH_PORTRAYLAYER_POST_ERROR,
            payload: []
        });
    });
};

export const updatelayerorder = (newLayerOrder, oldLayerOrder, layerId, keyword, offset, limit) => async dispatch => {
    const query = "query{updatelayerorder( newLayerOrder:" + newLayerOrder + ", oldLayerOrder:" + oldLayerOrder + ", layerId: " + layerId + ", sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.updatelayerorder.success) {
            dispatch(fetchLayer(keyword, offset, limit));
            dispatch({
                type: type.UPDATE_LAYER_ORDER_SUCCESS,
                payload: data.updatelayerorder.success,
                key: guid()
            });
        } else {
            if (data.updatelayerorder.message == type.SESSION_INVALID || data.updatelayerorder.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(fetchLayer(keyword, offset, limit));
            dispatch({
                type: type.UPDATE_LAYER_ORDER_ERROR,
                payload: [],
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.UPDATE_LAYER_ORDER_POST_ERROR ,
            payload: [],
            key: guid()
        });
    });
};

export const layerpublishstash = () => async dispatch => {
    const query = "query{updatelayerorder( newLayerOrder:  , oldLayerOrder:  , sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.updatelayerorder.success) {
            dispatch(fetchLayer('active'));
            dispatch({
                type: type.UPDATE_LAYER_ORDER_SUCCESS,
                payload: data.updatelayerorder.success,
                key: guid()
            });
        } else {
            if (data.updatelayerorder.message == type.SESSION_INVALID || data.updatelayerorder.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(fetchLayer('active'));
            dispatch({
                type: type.UPDATE_LAYER_ORDER_ERROR,
                payload: data.updatelayerorder.success
            });
        }
    }).catch(error => {
        dispatch({
            type: type.LAYER_PUBLISH_STASH_POST_ERROR,
            payload: []
        });
    });
};

export const getNotExpiredPackages = () => async dispatch => {
    const query = `query{selectnotexpiredpackages( sessionKey:"${localStorage.sessionKey}", apiKey:"${localStorage.apiKey}") { plid, apikey, packagename, subpackagename, expiry, success, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        const packageNames = [];
        if (data.selectnotexpiredpackages.length > 0) {
            if (data.selectnotexpiredpackages[0].message == 'Success') {
                for (var r = 0; r < data.selectnotexpiredpackages.length; r++) {
                    packageNames.push(data.selectnotexpiredpackages[r].packagename);
                }
                dispatch({
                    type: type.GET_NOT_EXPIRED_PACKAGES_SUCCESS,
                    payload: data.selectnotexpiredpackages,
                    packageNames: packageNames,
                    key: guid()
                });
            } else {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
        } else {
            return dispatch({
                type: type.GET_NOT_EXPIRED_PACKAGES_SUCCESS,
                payload: data.selectnotexpiredpackages,
                packageNames: packageNames,
                key: guid()
            });
        }
    }).catch(error => {
        localStorage.setItem("sessionKey", "");
        history.push("/signIn");
    });
};

export const fetchUserToSharePortrayal = (layerId) => async dispatch => {
    const query = `query{selectgroupuserwithoutspecificportrayallayer( layerId:${layerId},sessionKey:"${localStorage.getItem("sessionKey")}") { id, username, message }}`;
    const res = await axios.post(
        API_URL,
        JSON.stringify(getBody(query, { ip: "1.1.1.1" }))
    );
    const data = res.data.data;
    const userLists = [];
    if (data.selectgroupuserwithoutspecificportrayallayer[0].message == "empty") {
        return dispatch({
            type: type.FETCH_USER_TO_SHARE_PORTRAYAL_SUCCESS,
            payload: data.selectgroupuserwithoutspecificportrayallayer,
            userLists: userLists,
            key: guid()
        });
    }
    if (data.selectgroupuserwithoutspecificportrayallayer[0].message === type.SESSION_INVALID || data.selectgroupuserwithoutspecificportrayallayer[0].message === type.DDOS_SUSPECTED) {
        localStorage.setItem("sessionKey", "");
        history.push("/signIn");
    } else {
        for (var r = 0; r < data.selectgroupuserwithoutspecificportrayallayer.length; r++) {
            userLists.push({
                value: data.selectgroupuserwithoutspecificportrayallayer[r].id,
                label: data.selectgroupuserwithoutspecificportrayallayer[r].username
            })
        }
        return dispatch({
            type: type.FETCH_USER_TO_SHARE_PORTRAYAL_SUCCESS,
            payload: data.selectgroupuserwithoutspecificportrayallayer,
            userLists: userLists,
            key: guid()
        });
    }
};

export const shareLayerToSelectedUser = (userIds, layerId, layerName) => async dispatch => {
    const query = `query{insertportrayallayer(sessionKey: "${localStorage.getItem("sessionKey")}",userIds:"[${userIds}]",layerId:${layerId},layerName:"${layerName}") { message, success }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.insertportrayallayer.success) {
            dispatch({
                type: type.SHARE_LAYER_TO_SELECTED_USER__SUCCESS,
                payload: "you have succesfully shared layer",
                key: guid()
            });
        } else {
            if (data.insertportrayallayer.message === SESSION_INVALID || data.insertportrayallayer.message === DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.SHARE_LAYER_TO_SELECTED_USER__ERROR,
                payload: data.insertregisterpackage.message,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.SHARE_LAYER_TO_SELECTED_USER_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const updatelayerstatus = (layerStatus, layerId, keyword, offset, limit) => async dispatch => {
    const query = "query{updatelayerstatus( layerStatus:\"" + layerStatus + "\", layerId: " + layerId + ", sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.updatelayerstatus.success) {
            dispatch(fetchLayer(keyword, offset, limit));
            dispatch({
                type: type.UPDATE_LAYER_STATUS_SUCCESS,
                payload: data.updatelayerstatus.success,
                key: guid()
            });
        } else {
            if (data.updatelayerstatus.message == type.SESSION_INVALID || data.updatelayerstatus.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(fetchLayer(keyword, offset, limit));
            dispatch({
                type: type.UPDATE_LAYER_STATUS_ERROR,
                payload: [],
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.UPDATE_LAYER_STATUS_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const deregisterPublicLayer = (layerId, keyword, offset, limit) => async dispatch => {
    const query = `query{deregisterpubliclayer( sessionKey:"${localStorage.sessionKey}", publicLayerIds:"[${layerId}]" ) { success, message }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.deregisterpubliclayer.success) {
            dispatch(fetchLayer(keyword, offset, limit));
            dispatch({
                type: type.DEREGISTER_PUBLIC_LAYER_SUCCESS,
                payload: data.deregisterpubliclayer.success,
                key: guid()
            });
        } else {
            if (data.deregisterpubliclayer.message == type.SESSION_INVALID || data.deregisterpubliclayer.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(fetchLayer(keyword, offset, limit));
            dispatch({
                type: type.DEREGISTER_PUBLIC_LAYER_ERROR,
                payload: [],
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.DEREGISTER_PUBLIC_LAYER_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const publishtopublic = (layerId, keyword, offset, limit) => async dispatch => {
    const query = `query{insertpublishuri( layerId:${ layerId },apiKey:"${ localStorage.apiKey }",  category: \"\", sessionKey: "${localStorage.getItem("sessionKey") }") { message, success }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.insertpublishuri.success) {
            dispatch(fetchLayer(keyword, offset, limit));
            dispatch({
                type: type.PUBLISH_PUBLIC_SUCCESS,
                payload: data.insertpublishuri.success,
                key: guid()
            });
        } else {
            if (data.insertpublishuri.message === type.SESSION_INVALID || data.insertpublishuri.message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(fetchLayer(keyword, offset, limit));
            dispatch({
                type: type.PUBLISH_PUBLIC_ERROR,
                payload: [],
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.PUBLISH_PUBLIC_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};


export const fetchOwnPublicLayer = (keyword) => async dispatch => {
    const query = `query{getownpubliclayer( keyword:"${keyword}",sessionKey:"${localStorage.getItem("sessionKey")}") { layer_name,layer_id, publish_uri_id}}`;
  
    const layerList = [];
    if(keyword != '' && keyword != undefined)
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
       
        if (data.getownpubliclayer.length > 0)
        {
            if (data.getownpubliclayer[0].message === type.SESSION_INVALID || data.getownpubliclayer[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                for (var i=0; i <data.getownpubliclayer.length; i++){
                    layerList.push({
                        label: data.getownpubliclayer[i].layer_name,
                        value: data.getownpubliclayer[i].publish_uri_id
                    })
                }
               // dispatch(countOwnPublicLayer(keyword));
                return dispatch({
                    type: type.GET_OWN_PUBLIC_LAYER_SUCCESS,
                    payload: layerList,
                    key: guid()
                });
            }
        } else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            //dispatch(countOwnPublicLayer(keyword));
            return dispatch({
                type: type.GET_OWN_PUBLIC_LAYER_ERROR,
                payload: data.getownpubliclayer
            });
        }
    }).catch(error => {
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        return dispatch({
            type: type.GET_OWN_PUBLIC_LAYER_POST_ERROR,
            payload: []
        });
    });
};


export const createQuota = (pid,ceiling, price ) => async dispatch => {
    const query = `query{createQuota(pid:${pid}, ceiling:${ceiling}, price:${price},  sessionKey:"${localStorage.getItem("sessionKey")}") {  success, message}}`;
   
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.createQuota.success)
        {
            console.log(data);
           
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch(fetchQuota('active')); 
               // dispatch(countOwnPublicLayer(keyword));
                return dispatch({
                    type: type.CREATE_QUOTA_SUCCESS,
                    payload: data.createQuota.message,
                    key: guid()
                });
           
        }
         else {
            if (data.createQuota.message === type.SESSION_INVALID || data.createQuota.message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } 
 
            dispatch(fetchQuota('active')); 
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            return dispatch({
                type: type.CREATE_QUOTA_ERROR,
                payload: data.createQuota.message,
                key: guid()
            });
        }
    }).catch(error => {
        
    dispatch(fetchQuota('active')); 
    dispatch(checkUserRole());
    dispatch(getNotExpiredPackages());
        return dispatch({
            type: type.CREATE_QUOTA_POST_ERROR,
            payload:  error
        });
    });
};



export const fetchQuota = (keyword) => async dispatch => {
    const query = `query{getownpubliclayerquota( sessionKey:"${localStorage.getItem("sessionKey")}") { id, publish_uri_id, ceiling_limit, status, price, datetime_created, datetime_modified, layer_name}}`;
   
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
       // console.log(data);
        if (data.getownpubliclayerquota.length > 0)
        {
            if (data.getownpubliclayerquota[0].message === type.SESSION_INVALID || data.getownpubliclayerquota[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
               // dispatch(countOwnPublicLayer(keyword));
                return dispatch({
                    type: type.GET_OWN_PUBLIC_LAYER_QUOTA_SUCCESS,
                    payload: data.getownpubliclayerquota,
                    key: guid()
                });
            }
        } else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            //dispatch(countOwnPublicLayer(keyword));
            return dispatch({
                type: type.GET_OWN_PUBLIC_LAYER_QUOTA_ERROR,
                payload: data.getownpubliclayerquota
            });
        }
    }).catch(error => {
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        return dispatch({
            type: type.GET_OWN_PUBLIC_LAYER_QUOTA_POST_ERROR,
            payload: []
        });
    });
};



export const fetchSubscription = (keyword) => async dispatch => {
    const query = `query{getownsubscription(status:"${keyword}", sessionKey:"${localStorage.getItem("sessionKey")}") {id, latest_limit, layer_name, leftover, datetime_created, datetime_modified, status, success, message}}`;
   
    console.log(query);
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        console.log(data);
        if (data.getownsubscription.length > 0)
        {
            if (data.getownsubscription[0].message === type.SESSION_INVALID || data.getownsubscription[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
               // dispatch(countOwnPublicLayer(keyword));
                return dispatch({
                    type: type.GET_SUBSCRIPTION_SUCCESS,
                    payload: data.getownsubscription,
                    key: guid()
                });
            }
        } else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            //dispatch(countOwnPublicLayer(keyword));
            return dispatch({
                type: type.GET_SUBSCRIPTION_ERROR,
                payload: data.getownsubscription.message
            });
        }
    }).catch(error => {
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        return dispatch({
            type: type.GET_SUBSCRIPTION_POST_ERROR,
            payload: error
        });
    });
};


export const changeQuotaStatus = (uid, status) => async dispatch => {
    const query = `query{changequotastatus(uid:${uid},status:"${status}", sessionKey:"${localStorage.getItem("sessionKey")}") { success, message}}`;
   
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
       // console.log(data);
        if (data.changequotastatus.success)
        {
             
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch(fetchQuota('active')); 
               // dispatch(countOwnPublicLayer(keyword));
                return dispatch({
                    type: type.CHANGE_QUOTA_STAT_SUCCESS,
                    payload: data.changequotastatus.message,
                    key: guid()
                });
            
        } else {
            if (data.changequotastatus.message === type.SESSION_INVALID || data.changequotastatus.message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } 
                else{
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch(fetchQuota('active')); 
                //dispatch(countOwnPublicLayer(keyword));
                return dispatch({
                    type: type.CHANGE_QUOTA_STAT_ERROR,
                    payload: data.changequotastatus.message
                });
            }
        }
    }).catch(error => {
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        dispatch(fetchQuota('active')); 
        return dispatch({
            type: type.CHANGE_QUOTA_STAT_POST_ERROR,
            payload: error
        });
    });
};



export const changeSettingStatus = (uid, status) => async dispatch => {
    const query = `query{changesettingstatus(signature:"${uid}",status:"${status}", sessionKey:"${localStorage.getItem("sessionKey")}") { success, message}}`;
   
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
       // console.log(data);
        if (data.changesettingstatus .success)
        {
            if (data.changesettingstatus.message === type.SESSION_INVALID || data.changesettingstatus.message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages()); 
                dispatch(fetchProject('active'));
               // dispatch(countOwnPublicLayer(keyword));
                return dispatch({
                    type: type.CHANGE_SETTING_STAT_SUCCESS,
                    payload: data.changesettingstatus.message,
                    key: guid()
                });
            }
        } else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            dispatch(fetchProject('active'));
            //dispatch(countOwnPublicLayer(keyword));
            return dispatch({
                type: type.CHANGE_SETTING_STAT_ERROR,
                payload: data.changesettingstatus.message
            });
        }
    }).catch(error => {
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        dispatch(fetchProject('active'));
        return dispatch({
            type: type.CHANGE_SETTING_STAT_POST_ERROR,
            payload: error
        });
    });
};
export const countOwnPublicLayer= (keyword) => async dispatch => {
    const query = "query{countownpubliclayer( keyword: \"" + keyword + "\",sessionKey: \"" + localStorage.getItem("sessionKey") + "\") { count, message, success }}";
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.countlayerjoinportrayalbystatusandownlogin.success) {
            return dispatch({
                type: type.COUNT_LAYER_SUCCESS,
                payload: data.countlayerjoinportrayalbystatusandownlogin.success,
                count: data.countlayerjoinportrayalbystatusandownlogin.count
            });
        } else {
            if (data.countlayerjoinportrayalbystatusandownlogin.message == type.SESSION_INVALID || data.countlayerjoinportrayalbystatusandownlogin.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            return dispatch({
                type: type.COUNT_LAYER_ERROR,
                payload: data.countlayerjoinportrayalbystatusandownlogin.success,
                count: []
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.COUNT_LAYER_POST_ERROR,
            payload: [],
            count: []
        });
    });
};

export const updatepassword = (user, history) => async dispatch => {
    const {
        oldPassword,
        newPassword
    } = user;
    const query = `query{updatepassword( oldPassword:"${oldPassword}", newPassword:"${newPassword}", sessionKey:"${localStorage.sessionKey}" ) { success, message }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.updatepassword.success) {
            dispatch({
                type: type.UPDATE_PASSWORD_SUCCESS,
                payload: data.updatepassword.success,
                key: guid()
            });
        } else {
            if (data.updatepassword.message == type.SESSION_INVALID || data.updatepassword.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.UPDATE_PASSWORD_ERROR,
                payload: data.updatepassword.message,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.UPDATE_PASSWORD_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const getPublishLayerView = (keyword, fromDate, toDate, offset, limit) => async dispatch => {
    const query = `query{selectpublishlayerviewpaginate( keyword:"${keyword}", fromDate:"${fromDate}", toDate:"${toDate}", setOffset:${offset}, setLimit:${limit}, apiKey:"${localStorage.apiKey}", sessionKey:"${localStorage.sessionKey}") { plv_id, layer_name, company_name, category, datetime_access, success, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.selectpublishlayerviewpaginate.length > 0) {
            if (data.selectpublishlayerviewpaginate[0].message === type.SESSION_INVALID || data.selectpublishlayerviewpaginate[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch(countpublishlayerview(keyword, fromDate, toDate));
                return dispatch({
                    type: type.PUBLISH_LAYER_VIEW_SUCCESS,
                    payload: data.selectpublishlayerviewpaginate,
                    key: guid()
                });
            }
        }
        else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            dispatch(countpublishlayerview(keyword, fromDate, toDate));
            return dispatch({
                type: type.PUBLISH_LAYER_VIEW_SUCCESS,
                payload: data.selectpublishlayerviewpaginate,
                key: guid()
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.PUBLISH_LAYER_VIEW_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const getCountTotalPublishLayerViewed = () => async dispatch => {
    const query = `query{counttotalpublishlayerviewed( apiKey:"${localStorage.apiKey}", sessionKey:"${localStorage.sessionKey}") { count, id, layer_name, success, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.counttotalpublishlayerviewed.length > 0) {
            if (data.counttotalpublishlayerviewed[0].message === type.SESSION_INVALID || data.counttotalpublishlayerviewed[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                return dispatch({
                    type: type.COUNT_TOTAL_PUBLISH_LAYER_VIEWED_SUCCESS,
                    payload: data.counttotalpublishlayerviewed,
                    key: guid()
                });
            }
        }
        else {
            return dispatch({
                type: type.COUNT_TOTAL_PUBLISH_LAYER_VIEWED_SUCCESS,
                payload: data.counttotalpublishlayerviewed,
                key: guid()
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.COUNT_TOTAL_PUBLISH_LAYER_VIEWED_POST_ERROR,
            payload: []
        });
    });
};

export const getLayerName = () => async dispatch => {
    const query = `query{getlayername( sessionKey:"${localStorage.sessionKey}") { layer_name, success, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.getlayername.length > 0) {
            if (data.getlayername[0].message === type.SESSION_INVALID || data.getlayername[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                return dispatch({
                    type: type.GET_LAYER_NAME_SUCCESS,
                    payload: data.getlayername,
                    key: guid()
                });
            }
        }
        else {
            return dispatch({
                type: type.GET_LAYER_NAME_SUCCESS,
                payload: data.getlayername,
                key: guid()
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.GET_LAYER_NAME_POST_ERROR,
            payload: []
        });
    }); 
};

export const getPublicLayer = (keyword, offset, limit) => async dispatch => {
    const query = `query{getpubliclayer( keyword:"${keyword}", setOffset:${offset}, setLimit:${limit}, status:"active", sessionKey:"${localStorage.sessionKey}") { id, owner_user_id, layer_id, publish_uri, category, ceiling_limit, price, layer_name, datetime_created, company_name, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.getpubliclayer.length > 0) {
            if (data.getpubliclayer[0].message === type.SESSION_INVALID || data.getpubliclayer[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch(countPublicLayer(keyword));
                return dispatch({
                    type: type.GET_PUBLIC_LAYER_SUCCESS,
                    payload: data.getpubliclayer,
                    key: guid()
                });
            }
        }
        else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            dispatch(countPublicLayer(keyword));
            return dispatch({
                type: type.GET_PUBLIC_LAYER_SUCCESS,
                payload: data.getpubliclayer,
                key: guid()
            });
        }
    }).catch(error => {
        
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        dispatch(countPublicLayer(keyword));
        return dispatch({
            type: type.GET_PUBLIC_LAYER_POST_ERROR,
            payload: []
        });
    });
};

export const countPublicLayer = (keyword) => async dispatch => {
    const query = `query{countpubliclayer( keyword:"${keyword}",status:"active",sessionKey:"${localStorage.getItem("sessionKey")}") { count, message, success }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.countpubliclayer.success) {
            return dispatch({
                type: type.COUNT_PUBLIC_LAYER_SUCCESS,
                payload: data.countpubliclayer.success,
                count: data.countpubliclayer.count
            });
        } else {
            if (data.countpubliclayer.message == type.SESSION_INVALID || data.countpubliclayer.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            return dispatch({
                type: type.COUNT_PUBLIC_LAYER_ERROR,
                payload: data.countpubliclayer.success,
                count: []
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.COUNT_PUBLIC_LAYER_POST_ERROR,
            payload: [],
            count: []
        });
    });
};


export const countPublicLayerRequest = (keyword) => async dispatch => {
    const query = `query{countpubliclayerrequest( oid:0,status:"${keyword}",sessionKey:"${localStorage.getItem("sessionKey")}") { count, message, success }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.countpubliclayerrequest.success) {
            return dispatch({
                type: type.COUNT_REQUEST_PUBLIC_LAYER_SUCCESS,
                payload: data.countpubliclayerrequest.success,
                count: data.countpubliclayerrequest.count
            });
        } else {
            if (data.countpubliclayerrequest.message == type.SESSION_INVALID || data.countpubliclayerrequest.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            return dispatch({
                type: type.COUNT_REQUEST_PUBLIC_LAYER_ERROR,
                payload: data.countpubliclayerrequest.success,
                count: []
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.COUNT_REQUEST_PUBLIC_LAYER_POST_ERROR,
            payload: [],
            count: []
        });
    });
};

export const getPublicLayerRequest = (keyword, offset, limit) => async dispatch => {
    const query = `query{viewPublicLayerRequest(  setOffset:${offset}, setLimit:${limit},oid:0, status:"${keyword}", sessionKey:"${localStorage.sessionKey}") { id, request_user_id, layer_id,datetime_request, ceiling_limit, price, status,  company_name, layer_name }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.viewPublicLayerRequest.length > 0) {
            if (data.viewPublicLayerRequest[0].message === type.SESSION_INVALID || data.viewPublicLayerRequest[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages());
                dispatch(countPublicLayerRequest(keyword));
                return dispatch({
                    type: type.REQUEST_PUBLIC_LAYER_SUCCESS,
                    payload: data.viewPublicLayerRequest, 
                    key: guid()
                });
            }
        }
        else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages());
            dispatch(countPublicLayerRequest(keyword));
            return dispatch({
                type: type.REQUEST_PUBLIC_LAYER_ERROR,
                payload: data.getPublicLayerRequest,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages());
        dispatch(countPublicLayerRequest(keyword));
        return dispatch({
            type: type.REQUEST_PUBLIC_LAYER_POST_ERROR,
            payload: []
        });
    });
};

export const approvePublicLayerRequest = (lid, rid) => async dispatch => {
    const query = `query{approvePublicLayerRequest( lid:${lid}, requestid:${rid},  sessionKey:"${localStorage.sessionKey}") { success, message}}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.approvePublicLayerRequest.length > 0) {
            if (data.approvePublicLayerRequest[0].message === type.SESSION_INVALID || data.approvePublicLayerRequest[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(checkUserRole());
                dispatch(getNotExpiredPackages()); 
                dispatch(countPublicLayerRequest('pending'));
              //  dispatch(getPublicLayerRequest('pending', 0,5));
                return dispatch({
                    type: type.APPROVE_REQUEST_PUBLIC_LAYER_SUCCESS,
                    payload: data.approvePublicLayerRequest,
                    key: guid()
                });
            }
        }
        else {
            dispatch(checkUserRole());
            dispatch(getNotExpiredPackages()); 
            dispatch(countPublicLayerRequest('pending'));
          //  dispatch(getPublicLayerRequest('pending', 0,5));
            return dispatch({
                type: type.APPROVE_REQUEST_PUBLIC_LAYER_ERROR,
                payload: data.approvePublicLayerRequest,
                key: guid()
            });
        }
    }).catch(error => {   
        dispatch(checkUserRole());
        dispatch(getNotExpiredPackages()); 
        dispatch(countPublicLayerRequest('pending'));
        //dispatch(getPublicLayerRequest('pending', 0,5));
        return dispatch({
            type: type.APPROVE_REQUEST_PUBLIC_LAYER_POST_ERROR,
            payload: []
        });
    });
};

export const registerPublicLayer = (layerIds, userIds, id, keyword, offset, limit) => async dispatch => { //layerIds:"[${layerIds}]", userIds:"[${userIds}]",
    const query = `query{requestplayerret( sessionKey:"${localStorage.getItem("sessionKey")}",  plqid:${id}) { datetime_request, message, success  }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.requestplayerret.success) {
            dispatch(getPublicLayer(keyword, offset, limit));
            dispatch({
                type: type.REGISTER_PUBLIC_LAYER_SUCCESS,
                payload: data.requestplayerret.success,
                key: guid()
            });
        } else {
            if (data.requestplayerret.message == type.SESSION_INVALID || data.requestplayerret.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(getPublicLayer(keyword, offset, limit));
            dispatch({
                type: type.REGISTER_PUBLIC_LAYER_ERROR,
                payload: [],
                key: guid()
            });
        }
    }).catch(error => {
        dispatch(getPublicLayer(keyword, offset, limit));
        dispatch({
            type: type.REGISTER_PUBLIC_LAYER_POST_ERROR,
            payload: error,
            key: guid()
        });
    });
};

export const getUpdateFromLayer = () => async dispatch => {
    const query = `query{layerwithstatusinputownlogin( status:"stashed", sessionKey:"${localStorage.sessionKey}") { id, layer_name, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.layerwithstatusinputownlogin.length > 0) {
            if (data.layerwithstatusinputownlogin[0].message === type.SESSION_INVALID || data.layerwithstatusinputownlogin[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(getNotExpiredPackages());
                dispatch(getUpdateToLayer());
                return dispatch({
                    type: type.GET_UPDATE_FROM_LAYER_SUCCESS,
                    payload: data.layerwithstatusinputownlogin,
                    key: guid()
                });
            }
        }
        else {
            dispatch(getNotExpiredPackages());
            dispatch(getUpdateToLayer());
            return dispatch({
                type: type.GET_UPDATE_FROM_LAYER_SUCCESS,
                payload: data.layerwithstatusinputownlogin,
                key: guid()
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.GET_UPDATE_FROM_LAYER_POST_ERROR,
            payload: []
        });
    });
};

export const getUpdateToLayer = () => async dispatch => {
    const query = `query{layernotinportrayalandpublishuri( status:"active", sessionKey:"${localStorage.sessionKey}") { id, layer_name, message }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.layernotinportrayalandpublishuri.length > 0) {
            if (data.layernotinportrayalandpublishuri[0].message === type.SESSION_INVALID || data.layernotinportrayalandpublishuri[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                return dispatch({
                    type: type.GET_UPDATE_TO_LAYER_SUCCESS,
                    payload: data.layernotinportrayalandpublishuri,
                    key: guid()
                });
            }
        }
        else {
            return dispatch({
                type: type.GET_UPDATE_TO_LAYER_SUCCESS,
                payload: data.layernotinportrayalandpublishuri,
                key: guid()
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.GET_UPDATE_TO_LAYER_POST_ERROR,
            payload: []
        });
    });
};

export const requestUpdateLayer = (fromLayerId, toLayerId) => async dispatch => {
    const query = `query{insertrequestupdatepublishuri( sessionKey:"${localStorage.getItem("sessionKey")}", fromLayerId:${fromLayerId}, toLayerId:${toLayerId}) { message, success }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.insertrequestupdatepublishuri.success) {
            dispatch({
                type: type.REQUEST_UPDATE_LAYER_SUCCESS,
                payload: data.insertrequestupdatepublishuri.success,
                key: guid()
            });
        } else {
            if (data.insertrequestupdatepublishuri.message == type.SESSION_INVALID || data.insertrequestupdatepublishuri.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch({
                type: type.REQUEST_UPDATE_LAYER_ERROR,
                payload: [],
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.REQUEST_UPDATE_LAYER_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

export const getRequestUpdatePublishUri = (keyword, offset, limit) => async dispatch => {
    const query = `query{requestupdatepublishuri( keyword:"${keyword}" , status:"pending", offset:${offset}, limit:${limit}, sessionKey:"${localStorage.sessionKey}") { id, from_layer_name, to_layer_name, modified_by, datetime_request }}`;
    await axios.post(
        API_URL,
        JSON.stringify(getBody(query))
    ).then(response => {
        const data = response.data.data;
        if (data.requestupdatepublishuri.length > 0) {
            if (data.requestupdatepublishuri[0].message === type.SESSION_INVALID || data.requestupdatepublishuri[0].message === type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            } else {
                dispatch(countRequestUpdatePublishUri(keyword));
                return dispatch({
                    type: type.GET_REQUEST_UPDATE_PUBLISH_URI_SUCCESS,
                    payload: data.requestupdatepublishuri,
                    key: guid()
                });
            }
        }
        else {
            dispatch(countRequestUpdatePublishUri(keyword));
            return dispatch({
                type: type.GET_REQUEST_UPDATE_PUBLISH_URI_SUCCESS,
                payload: data.requestupdatepublishuri,
                key: guid()
            });
        }
    }).catch(error => {
        return dispatch({
            type: type.GET_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR,
            payload: []
        });
    });
};

export const approveRequestUpdatePublishUri = (requestLayerId, keyword, offset, limit) => async dispatch => {
    const query = `query{approverequestupdatepublishuri( requestLayerId:${requestLayerId}, sessionKey:"${localStorage.sessionKey}") { success, message }}`;
    await axios.post(API_URL, JSON.stringify(getBody(query))).then(response => {
        const data = response.data.data;
        if (data.approverequestupdatepublishuri.success) {
            dispatch(getRequestUpdatePublishUri(keyword, offset, limit));
            dispatch(countRequestUpdatePublishUri(keyword));
            dispatch({
                type: type.APPROVE_REQUEST_UPDATE_PUBLISH_URI_SUCCESS,
                payload: data.approverequestupdatepublishuri.success,
                key: guid()
            });
        } else {
            if (data.approverequestupdatepublishuri.message == type.SESSION_INVALID || data.approverequestupdatepublishuri.message == type.DDOS_SUSPECTED) {
                localStorage.setItem("sessionKey", "");
                history.push("/signIn");
            }
            dispatch(getRequestUpdatePublishUri(keyword, offset, limit));
            dispatch(countRequestUpdatePublishUri(keyword));
            dispatch({
                type: type.APPROVE_REQUEST_UPDATE_PUBLISH_URI_ERROR,
                payload: data.approverequestupdatepublishuri.success,
                key: guid()
            });
        }
    }).catch(error => {
        dispatch({
            type: type.APPROVE_REQUEST_UPDATE_PUBLISH_URI_POST_ERROR,
            payload: [],
            key: guid()
        });
    });
};

function getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        cb(reader.result)
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };
}

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

const getBody = (query, variables) => {
  return {
    OperationName: "",
    Query: query,
    Variables: variables
  };
};

const parseFile = (file, callback) => {
    var fileSize   = file.size;
    var chunkSize  = 64 * 1024; // bytes
    var offset     = 0;
    var self       = this; // we need a reference to the current object
    var chunkReaderBlock = null;

    var readEventHandler = function(evt) {
        if (evt.target.error == null) {
            offset += evt.target.result.length;
            callback(evt.target.result); // callback for handling read chunk
        } else {
            console.log("Read error: " + evt.target.error);
            return;
        }
        if (offset >= fileSize) {
            console.log("Done reading file");
            return;
        }

        // of to the next chunk
        chunkReaderBlock(offset, chunkSize, file);
    }

    chunkReaderBlock = function(_offset, length, _file) {
        var r = new FileReader();
        var blob = _file.slice(_offset, length + _offset);
        r.onload = readEventHandler;
        r.readAsDataURL(blob);
    }

    // now let's start the read with the first block
    chunkReaderBlock(offset, chunkSize, file);
}


// WEBPACK FOOTER //
// ./src/actions/index.js